import classNames from "classnames";
import { HTMLProps, ReactNode, useRef, useState } from "react";

const Tooltip = ({
  children,
  text,
  hidden = false,
  isTruncate = true,
  className,
  arrowPosition,
}: {
  children?: ReactNode;
  text: ReactNode;
  isTruncate?: boolean;
  hidden?: boolean;
  className?: HTMLProps<HTMLElement>["className"];
  arrowPosition?: "right" | "left" | "top" | "bottom" | undefined;
}) => {
  const [isShowing, setIsShowing] = useState(false);

  const hoverTimer = useRef<number | null>(null);

  const handleMouseEnter = () => {
    hoverTimer.current = window.setTimeout(() => {
      setIsShowing(true);
    }, 0);
  };

  const handleMouseLeave = () => {
    if (hoverTimer.current) {
      clearTimeout(hoverTimer.current);
    }
    setIsShowing(false);
  };

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="relative z-30"
    >
      <div
        className={classNames(
          "absolute origin-left duration-[100ms] transition-all flex flex-col justify-center shadow-[1px_1px_8px_0px_rgba(0,0,0,0.08)] bg-white rounded right-3 translate-x-full",
          {
            "scale-x-0": !isShowing || hidden,
          },
          className,
        )}
      >
        <div className="relative px-2">
          {arrowPosition && (
            <div
              className={classNames(
                "absolute !text-gray-400 shadow-[1px_1px_8px_0px_rgba(0,0,0,0.08)] w-0 h-0 border-t-[5px] border-b-[5px] border-r-[5px] border-transparent",
                {
                  "left-0 top-1/2 -translate-y-1/2 -translate-x-full":
                    arrowPosition === "left",
                  "right-0 top-1/2 -translate-y-1/2 translate-x-full rotate-180":
                    arrowPosition === "right",
                  "bottom-0 right-1/2 translate-x-full translate-y-full -rotate-90":
                    arrowPosition === "bottom",
                  "top-0 right-1/2 translate-x-full -translate-y-full rotate-90":
                    arrowPosition === "top",
                },
              )}
            />
          )}
          <div
            className={`text-[14px] ${isTruncate ? "truncate" : ""} leading-6`}
          >
            {text}
          </div>
        </div>
      </div>
      {children}
    </div>
  );
};

export default Tooltip;
